import React from "react";
import { FactoryIcon } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 3 (Family C) — Industrial Zones, Utilities & Service Operators
const IndustrialZone = () => (
  <SolutionPageLayout
    testId="page-solution-industrial-zone"
    icon={FactoryIcon}
    overline="Pathway · 03 of 07 · Aligned with Family C"
    title="For Industrial Zones, Utilities & Service Operators"
    headline="Stronger control over subscribers, services, consumption, field work, payments, portals, and operational visibility."
    intro={[
      "For organized industrial zones, business parks, utility-based institutions, service operators, infrastructure-linked environments, and estate-style operating structures that need stronger control over subscribers, services, consumption, field work, payments, portals, and operational visibility.",
      "This pathway supports organizations where service delivery, infrastructure, utilities, tenants, industrialists, or member-based operations need to be managed through one clearer digital structure.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Industrial zone management",
      "Business park or estate-style service operations",
      "Utility subscriber management",
      "Electricity, water, natural gas, or similar service processes",
      "Industrialist, tenant, or member portals",
      "Meter reading, mobile meter reading, and automated meter reading readiness",
      "Mobile work orders and maintenance processes",
      "Payment points, direct debit readiness, and collection workflows",
      "Infrastructure and field-service coordination",
    ]}
    ctaTitle="Structure industrial zone, utility, and service-operator operations with stronger visibility."
    primaryCta={{ label: "Discuss Industrial & Utility Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#industrial-zone-utility-management" }}
  />
);

export default IndustrialZone;
